import { useState, useEffect } from 'react';

const Countdown = () => {
  const [timeLeft, setTimeLeft] = useState({
    dias: 0,
    horas: 0,
    minutos: 0,
    segundos: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const weddingDate = new Date('2026-09-12T12:00:00');
      const now = new Date();
      const difference = weddingDate - now;

      if (difference > 0) {
        const dias = Math.floor(difference / (1000 * 60 * 60 * 24));
        const horas = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutos = Math.floor((difference / 1000 / 60) % 60);
        const segundos = Math.floor((difference / 1000) % 60);

        setTimeLeft({ dias, horas, minutos, segundos });
      }
    };

    const timer = setInterval(calculateTimeLeft, 1000);
    calculateTimeLeft();

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="py-16 px-4 bg-rose-600 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="font-great-vibes text-4xl mb-8">Tan solo quedan..</h2>
        
        <div className="flex justify-center gap-4 md:gap-6">
          {Object.entries(timeLeft).map(([unit, value]) => (
            <div key={unit} className="bg-white bg-opacity-20 rounded-lg p-4 w-20 md:w-24 backdrop-blur-sm">
              <div className="text-3xl md:text-4xl font-bold">{value}</div>
              <div className="text-sm uppercase">{unit}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Countdown;